/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_LoadingInputs */

const en_us2_workout_after_loading = /** @type {(inputs: Workout_After_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading the summary…`)
};

const pt_br2_workout_after_loading = /** @type {(inputs: Workout_After_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando o resumo…`)
};

const es_419_workout_after_loading = /** @type {(inputs: Workout_After_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando el resumen…`)
};

const pt_pt2_workout_after_loading = /** @type {(inputs: Workout_After_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A carregar o resumo…`)
};

const fr_fr2_workout_after_loading = /** @type {(inputs: Workout_After_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement du résumé…`)
};

const de_de2_workout_after_loading = /** @type {(inputs: Workout_After_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusammenfassung wird geladen…`)
};

const it_it2_workout_after_loading = /** @type {(inputs: Workout_After_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento del riepilogo…`)
};

/**
* | output |
* | --- |
* | "Loading the summary…" |
*
* @param {Workout_After_LoadingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_loading = /** @type {((inputs?: Workout_After_LoadingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_LoadingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_loading(inputs)
	if (locale === "es-419") return es_419_workout_after_loading(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_loading(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_loading(inputs)
	if (locale === "de-DE") return de_de2_workout_after_loading(inputs)
	if (locale === "it-IT") return it_it2_workout_after_loading(inputs)
	return en_us2_workout_after_loading(inputs)
});
export { workout_after_loading as "workout-after.loading" }